export const stringify = (params: object): string => {
  const query = new URLSearchParams();

  // eslint-disable-next-line no-restricted-syntax
  for (const [key, value] of Object.entries(params)) {
    if (Array.isArray(value)) {
      // eslint-disable-next-line no-restricted-syntax
      for (const item of value) {
        query.append(key, item);
      }
    } else if (value !== null && value !== undefined && value !== '') {
      // Skip undefined too: otherwise URLSearchParams serialises it as the
      // literal string "undefined" (e.g. `?cursor=undefined`), which the
      // backend's cursor validator rejects with 400 invalid-cursor.
      query.append(key, value);
    }
  }

  return `${query}`;
};
